import React from 'react';
import { SxProps } from '@mui/system';
import { DurationBetweenTwoDatesIconField } from 'framework/ui/field';
import { useDateService } from 'framework/utils';

interface HealthcheckStatusConfig {
  textColor: string;
  buttonColor: string;
}

type StatusCalculatorFunction = (months: number) => string;

interface HealthcheckStatusProps {
  iconSx?: SxProps;
  textSx?: SxProps;
  className?: string;
  style?: React.CSSProperties;
  dateFromSource?: string;
  statusConfig: Record<string, HealthcheckStatusConfig>;
  getStatusByMonths: StatusCalculatorFunction;
}

const HealthcheckStatus: React.FC<HealthcheckStatusProps> = ({
  iconSx,
  textSx,
  className,
  style,
  dateFromSource = 'retentionRiskLastHealthcheck',
  statusConfig,
  getStatusByMonths,
}) => {
  const { getMomentDateObj, getMonthsBetween } = useDateService();

  return (
    <DurationBetweenTwoDatesIconField
      dateFromSource={dateFromSource}
      iconSx={iconSx}
      textSx={textSx}
      className={className}
      style={style}
      textColor={(startDate, endDate) => {
        const monthsDiff = getMonthsBetween(endDate, getMomentDateObj(startDate)) || 0;
        const statusType = getStatusByMonths(monthsDiff);
        return statusConfig[statusType]?.textColor || 'text.primary';
      }}
    />
  );
};

export default HealthcheckStatus;
